import React from "react";
import "./Herosection.css";
import { NavLink } from "react-router-dom";

const Herosection = () => {
  return (
    <div className="herosection">
      <div className="herosection-contents">
        <div className="intro">
          <p className="title">
            Our prime showcase of emerging leaders and innovators.
          </p>
          <div className="bottom-section">
            <NavLink to="/projects">
              <button className="hero-btn hero-btn-main">
                BROWSE PROJECTS
              </button>
            </NavLink>
            {/* "Become a Judge" button hidden per team decision (June 2026).
                Restore by uncommenting when judge applications reopen. */}
            {/* <a
              href="https://docs.google.com/forms/d/1i8THkmJn0ugdHYCynHIvSPHQ-2-lTf56gHPvhyRr8g8/viewform"
              target="_blank"
              rel="noopener noreferrer"
            >
              <button className="hero-btn hero-btn-main">
                BECOME A JUDGE
              </button>
            </a> */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Herosection;
